import React, { useState, useEffect } from 'react';
import { MaterialIcons } from '@expo/vector-icons';
import {
    Text, View, Image, StyleSheet, ImageBackground
} from 'react-native';
import { store } from '../../store/store';
import { Ampersand } from '../../utils/constants/AppConstants';
import { updateReduxEConsultInfo } from '../../utils/services/redux/commonRedux';
import { PrimaryCTA } from '../../utils/widgets/CommonCTA';
import { NavigateFrom, ScreenRoute } from '../../utils/constants/ScreenRouteConstant';
import { EmptyHeader } from '../../utils/widgets/CommonWidget/CommonHeader';
import { WAUpdateToggleView } from '../../utils/widgets/Common-Widget';
import { trackMoengageEvents } from '../../utils/services/webapp-services/MoengageUtils';

import { refreshEConsult } from '../../utils/services/econsult/EConsultUtils';

import AppStyles from "../../AppStyles";
import AppTheme from "../../AppTheme";

import * as Animatable from "react-native-animatable";
import * as CommonUtils from '../../utils/services/CommonUtils';

const EconsultCreated = (props) => {

    // const [waUpdates, waUpdatesSet] = React.useState(1);
    const [waState, updateWAState] = React.useState({
        optInState: 0,
        update: false
    })
    const [eConsultInfo, updateInfo] = useState({
        name: '',
        phoneNumber: '',
        consultId: 0,
        consultHashcode: '',
        renderState: false,
        // fbqData: {
        //     caseCode: '',
        //     plan_id: '-1',
        //     walletBalance: -1,
        //     toPay: -1,
        // },
    });

    const navigate = () => {
        props.navigation.popToTop();
        global.navigateFrom = NavigateFrom.econsult_success + ',' + eConsultInfo.consultId
        props.navigation.replace(ScreenRoute.dashboard_screen)
    }

    useEffect(() => {
        const reduxState = store.getState();
        trackMoengageEvents('econsult_completed');
        if (reduxState.whatsappOptInState !== undefined)
            updateWAState({
                optInState: reduxState.whatsappOptInState,
                update: false
            })
        if (reduxState.eConsultInfo)
            updateInfo({
                name: reduxState.eConsultInfo['memberName'],
                phoneNumber: reduxState.eConsultInfo['phoneNumber'],
                consultId: reduxState.eConsultInfo['consultationId'],
                consultHashcode: reduxState.eConsultInfo['consultationHashcode'],
                renderState: true,
                // name: 'Member Name',
                // phoneNumber: '743848338982',
                // consultId: 32878,
                // consultHashcode: '37267267',
                // renderState: true,
            });
        updateReduxEConsultInfo({})
        refreshEConsult()
    }, [])

    return (


        <ImageBackground source={{ uri: CommonUtils.getImagePath('/images/whatsapp_bg.png') }}
            style={{ width: AppTheme.appWidth, height: AppTheme.appHeight, paddingTop: 36 }}>

            <EmptyHeader navigation={props.navigation} />

            <View style={{ paddingHorizontal: 16 }}>
                <Animatable.View animation="fadeIn"
                    duration={AppTheme.transitionDuration}
                    delay={(AppTheme.transitionDuration) / 5}
                    useNativeDriver style={{ flexDirection: "column", justifyContent: "center", alignItems: 'center', margin: 14, }}>
                    <MaterialIcons style={[AppStyles.greenCircle]} name={'check'} size={30} color={AppTheme.color.white} />
                    <Text style={styles.successMsg}>   E-CONSULT CREATED SUCCESSFULLY</Text>
                </Animatable.View>
                <View style={{}}>
                    <Animatable.View animation="fadeInUp"
                        duration={AppTheme.transitionDuration}
                        delay={(1 * AppTheme.transitionDuration) / 5}
                        useNativeDriver style={[AppStyles.flexRowCenter, { marginBottom: 50 }]}>
                        <Text style={styles.Icon}><Image source={{
                            uri: CommonUtils.getImagePath('/images/econsult_created_2.svg'),
                            width: 35, height: 35
                        }} style={{ alignContent: 'center' }} /></Text>
                        <Text style={styles.IconText}>An expert doctor will review your case {Ampersand}
                            <Text style={{ fontWeight: '600' }}> call you on "{eConsultInfo.phoneNumber}" within 30 minutes</Text></Text>
                    </Animatable.View>
                    <Animatable.View animation="fadeInUp"
                        duration={AppTheme.transitionDuration}
                        delay={(3 * AppTheme.transitionDuration) / 5}
                        useNativeDriver style={[AppStyles.flexRowCenter, { marginBottom: 50 }]}>
                        <Text style={styles.Icon}><Image source={{
                            uri: CommonUtils.getImagePath('/images/econsult_created_1.svg'),
                            width: 35, height: 35
                        }} style={{ alignContent: 'center' }} /></Text>
                        <Text style={styles.IconText}>Doctor will share you a prescription after consultation</Text>
                    </Animatable.View>
                    <Animatable.View animation="fadeInUp"
                        duration={AppTheme.transitionDuration}
                        delay={(5 * AppTheme.transitionDuration) / 5}
                        useNativeDriver style={[AppStyles.flexRowCenter, { marginBottom: 16 }]}>
                        <Text style={styles.Icon}>
                            <Image source={{
                                uri: CommonUtils.getImagePath('/images/econsult_created_3.svg'),
                                width: 35, height: 35
                            }} style={{ alignContent: 'center' }} /></Text>
                        <Text style={styles.IconText}>
                            Share the problem openly with the doctor for best treatment</Text>
                    </Animatable.View>
                </View>

                {waState.optInState == 1 ? <View /> : <Animatable.View animation="slideInUp"
                    duration={AppTheme.transitionDuration} useNativeDriver
                    delay={(6 * AppTheme.transitionDuration) / 5}>
                    <WAUpdateToggleView activity={'consult'}
                        waState={waState} updateWAState={updateWAState} />
                </Animatable.View>}
            </View >

            <Animatable.View animation="slideInUp" useNativeDriver
                duration={AppTheme.transitionDuration}
                delay={(6 * AppTheme.transitionDuration) / 5}
                style={[AppStyles.bottomFix]}>
                <PrimaryCTA marginVertical={10}
                    title={'VIEW DETAILS'} action={() => navigate()} />
            </Animatable.View>
        </ImageBackground >
    )
}

export default EconsultCreated;

const styles = StyleSheet.create(CommonUtils.addFontFamilylato({
    getUpdates: {
        color: AppTheme.color.primary, textDecorationLine: "underline",
        fontSize: 15, paddingLeft: 10, textAlign: "center"
    },
    Bar: {
        width: 1,
        height: 7,
        backgroundColor: '#0071fa',
        margin: 4,
        marginLeft: 20
    },
    Icon: {
        width: 50,
        height: 50,
        borderRadius: 50,
        backgroundColor: AppTheme.color.background,
        alignContent: "center",
        padding: 10,
        marginLeft: 9,
        marginRight: 13
    },
    IconText: {
        paddingLeft: 10,
        padding: 5, fontSize: 16, coloe: '#000000'
    },
    successMsg: {
        color: AppTheme.color.green.primary, padding: 16, textAlign: 'center', width: 300,
        fontSize: 24, lineHeight: 27, fontWeight: '600'
    },
    submit: {
        margin: 10, backgroundColor: '#ffffff', fontSize: 14,
        borderRadius: 4, color: '#ffffff', outlineWidth: 1,
        borderColor: AppTheme.color.primary,
        borderWidth: 1
    },
    submitOk: {
        marginTop: 10, paddingTop: 15, paddingBottom: 17, backgroundColor: AppTheme.color.blue.cta,
        borderRadius: 4, borderWidth: 1, borderColor: '#fff',
        marginBottom: 8, width: AppTheme.appWidth - 32
    },
}))
